import * as React from 'react'
import { FormikProps } from 'formik'

interface INewPasswordForm {
  password: string
  passwordConfirmation: string
}

const NewPasswordForm = (props: FormikProps<INewPasswordForm>) => {
  const { values, touched, errors, handleSubmit, handleChange, isSubmitting } = props
  return (
    <form className='w310 mt4' onSubmit={handleSubmit}>
      <div className='flex items-center'>
        <input
          className='p1 outline-none bg-transparent border-none bb-white w100'
          type='password'
          name='password'
          value={values.password}
          onChange={handleChange}
          placeholder='New password'
        />
      </div>
      <div className='flex items-center mt2'>
        <input
          className='w100 p1 outline-none bg-transparent border-none bb-white'
          type='Password'
          name='passwordConfirmation'
          value={values.passwordConfirmation}
          onChange={handleChange}
          placeholder='Password Confirmation'
        />
      </div>
      {errors.password && touched.password && <div className='block font-orange right-align'>{errors.password}</div>}
      {errors.passwordConfirmation && touched.passwordConfirmation && (
        <div className='block font-orange right-align'>{errors.passwordConfirmation}</div>
      )}
      <button
        className='SignIn col-12 py2 h3 cursor--pointer border-none mt2 rounded bg-white box-sizing font-green'
        disabled={isSubmitting}
      >
        Send
      </button>
    </form>
  )
}

export default NewPasswordForm



// WEBPACK FOOTER //
// ./src/components/authentication/NewPasswordForm.tsx